import { render, staticRenderFns } from "./NotifyAlert.vue?vue&type=template&id=b629fd02&"
import script from "./NotifyAlert.vue?vue&type=script&lang=js&"
export * from "./NotifyAlert.vue?vue&type=script&lang=js&"
import style0 from "./NotifyAlert.vue?vue&type=style&index=0&id=b629fd02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports